<template>
  <div class="container is-widescreen">
    <div class="columns is-centered">
      <div class="column is-8">
        <div class="header-bar">
          <div class="section-title">
            <h1>
              <span v-if="isProject">
                <span v-if="projectData.project_tnc_title">
                  {{ projectData.project_tnc_title }}
                </span>
                <span v-else>Términos y Condiciones</span>
              </span>
              <span v-else>Términos y Condiciones</span>
            </h1>
          </div>
        </div>

        <template v-if="isRelevant">
          <div class="resume-list">
            <div class="item">
              <div class="icon">
                <img
                  src=""
                  alt=""
                >
              </div>
              <div class="title">
                Uso de la plataforma
              </div>
              <div class="text">
                Muy lejos, más allá de las montañas de palabras, alejados de los
                países de las vocales y las consonantes, viven los textos
                simulados. Viven aislados en casas de letras, en la costa de la
                semántica, un gran océano de lenguas.
              </div>
            </div>

            <div class="item">
              <div class="icon">
                <img
                  src=""
                  alt=""
                >
              </div>
              <div class="title">
                Seguridad y datos personales
              </div>
              <div class="text">
                Muy lejos, más allá de las montañas de palabras, alejados de los
                países de las vocales y las consonantes, viven los textos
                simulados. Viven aislados en casas de letras, en la costa de la
                semántica, un gran océano de lenguas. Un riachuelo llamado Pons
                fluye por su pueblo y los abastece con las normas necesarias.
                Hablamos de un país paraisomático en el que a uno le caen
                pedazos de frases asadas en la boca.
              </div>
            </div>

            <div class="item">
              <div class="icon">
                <img
                  src=""
                  alt=""
                >
              </div>
              <div class="title">
                Conducta del usuario
              </div>
              <div class="text">
                Muy lejos, más allá de las montañas de palabras, alejados de los
                países de las vocales y las consonantes, viven los textos
                simulados. Viven aislados en casas de letras, en la costa de la
                semántica, un gran océano de lenguas.
              </div>
            </div>

            <div class="item">
              <div class="icon">
                <img
                  src=""
                  alt=""
                >
              </div>
              <div class="title">
                Copyright
              </div>
              <div class="text">
                Pero nada de lo dicho por la copia pudo convencerlo, de manera
                que al cabo de poco tiempo, unos pérfidos redactores
                publicitarios lo encontraron y emborracharon con Longe y Parole
                para llevárselo después a su agencia, donde abusaron de él para
                sus proyectos, una y otra vez. Y si aún no lo han reescrito, lo
                siguen utilizando hasta ahora.
              </div>
            </div>

            <div class="item read-more">
              <div class="text">
                <p><strong>¿Tenés dudas?</strong> Leé el documento completo</p>
                <button
                  class="btn-read-more"
                  @click="modalPlatform"
                >
                  Leer más
                </button>
              </div>
            </div>
          </div>
        </template>

        <template v-if="isProject">
          <div class="resume">
            <div class="item">
              <div class="text">
                <template v-if="projectData.project_tnc_description">
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span v-html="projectData.project_tnc_description" />
                </template>
                <template v-else>
                  Aun no hay Términos y Condiciones cargados para este proyecto.
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { parseURLTncType } from './tncURLs'

export default {
  name: 'TermsAndConditionsDetails',
  data() {
    return {
      termsType: parseURLTncType(this.$route.params.type),
      tncDescription: ''
    }
  },
  computed: {
    ...mapState('participationProject', ['projectData']),
    isRelevant() {
      return this.termsType === 'relevant'
    },
    isProject() {
      return this.termsType === 'project'
    }
  },
  created() {
    if (!this.termsType) {
      // Wrong URL param
      this.$router.push({
        name: 'participation-terms-and-conditions',
        params: { identifier: this.$route.params.identifier }
      })
    }
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    modalPlatform() {
      this.$buefy.dialog.confirm({
        title: 'Términos y Condiciones de Relevant',
        // eslint-disable-next-line max-len
        message: '<h2>Uso de la plataforma</h2>Muy lejos, más allá de las <strong>montañas de palabras</strong>, alejados de los países de las vocales y las consonantes, viven los textos simulados. Viven aislados en casas de letras, en la costa de la semántica, un gran océano de lenguas. Muy lejos, más allá de las montañas de palabras, alejados de los países de las vocales y las consonantes, viven los textos simulados. Viven aislados en casas de letras, en la costa de la semántica, un gran océano de lenguas.<br><br><h2>Seguridad y datos personales</h2>Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca. Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca. Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca. Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br><br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.<br> Un riachuelo llamado Pons fluye por su pueblo y los abastece con las normas necesarias. Hablamos de un país paraisomático en el que a uno le caen pedazos de frases asadas en la boca.',
        confirmText: 'Entendido',
        type: 'is-success',
        canCancel: false
      })
    },
    modalProject() {
      this.$buefy.dialog.confirm({
        title: 'Términos y Condiciones',
        message: `${this.tncDescription}`,
        confirmText: 'Entendido',
        type: 'is-success',
        canCancel: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;

    .section-title {
      h1 {
        font-size: 24px;
        font-weight: 600;
        color: $black;
      }
    }
  }

  .resume-list {
    .item {
      display: flex;
      flex-flow: column;
      align-items: center;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      padding: 20px 20px;
      margin-bottom: 16px;

      .icon {
        width: 56px;
        max-width: 56px;
        height: 56px;
        max-height: 56px;
        background-color: #eaf7fc;
        border-radius: 10px;
        margin-bottom: 17px;
      }

      .title {
        font-weight: 600;
        font-size: 20px;
        line-height: 22px;
        text-align: center;
        color: $blue;
        margin-bottom: 17px;
      }

      .text {
        font-family: $font-family-secondary;
        font-size: 16px;
        line-height: 24px;
        text-align: left;
        color: $gray-dark;
      }

      &.read-more {
        display: flex;
        flex-flow: row;

        .text {
          width: 100%;
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          align-items: center;
          color: $gray-dark;

          .btn-read-more {
            min-width: 120px;
            height: 35px;
            background-color: $blue;
            color: $white;
            border: none;
            border-radius: 20px;
            font-weight: 600;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease-in-out;

            &:hover {
              background-color: $blue-hover;
              transition: all 0.2s ease-in-out;
            }

            &.accepted {
              background-color: $green;
              background: $green url("../../../assets/terms/term-button-check.svg")
                16px 10px no-repeat;
              padding-left: 30px;
            }
          }
        }
      }
    }
  }

  .resume {
    .item {
      .text {
        font-family: $font-family-secondary;
        font-size: 16px;
        line-height: 24px;
        text-align: left;
        color: $gray-dark;
      }
    }
  }
}
</style>

<style lang="scss">
.resume {
  .item {
    .text {
      color: $gray-dark;

      p {
        color: $gray-dark;

        &.ql-align-right {
          text-align: right;
        }

        &.ql-align-center {
          text-align: center;
        }
      }

      h1,
      h2,
      h3 {
        font-weight: 600;
        color: $black;
      }

      h1 {
        font-size: 24px;
        line-height: 30px;
      }

      h2 {
        font-size: 18px;
        line-height: 24px;
      }

      h3 {
        font-size: 16px;
        line-height: 22px;
      }

      blockquote {
        border-left: 2px solid #ccc;
        padding: 7px 20px;
        font-style: italic;
      }
    }
  }
}
</style>
